import React from "react";
import Container from "../components/Container";
import HeaderBanner from "../components/HeaderBanner";
import useLocale from "../locales";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  const { textData } = useLocale();
  const aboutUs = textData?.aboutUs;
  return (
    <>
      <Helmet>
        <title>Who We Are – GrowLifeFund | Smarter Financial Calculators</title>
        <meta
          name="description"
          content="GrowLifeFund delivers precision with simplicity, giving clarity to your finances through crafted calculators and data-driven tools for smarter decisions."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://growlifefund.com/about-us" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Who We Are – GrowLifeFund | Smarter Financial Calculators"
        />
        <meta
          property="og:description"
          content="GrowLifeFund delivers precision with simplicity, giving clarity to your finances through crafted calculators and data-driven tools for smarter decisions."
        />
        <meta property="og:url" content="https://growlifefund.com/about-us" />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="GrowLifeFund financial calculators and tools"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Container>
        <div className="my-[24px] ">
          <HeaderBanner name={aboutUs?.header} backUrl="/" />
          <div>
            <p className="text-[#747878] sm:text-[16px] text-[14px] font-lato-regular-400">
              {aboutUs?.welcome}
            </p>
            <h2 className="text-gray-font sm:text-[18px] text-[16px] font-lato-medium-500 mt-[20px] ">
              {aboutUs?.tagline}
            </h2>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]">
              {aboutUs?.intro}
            </p>

            <h2 className="text-gray-font sm:text-[17px] text-[16px] font-lato-semibold-600 mt-[20px] underline ">
              {aboutUs?.missionTitle}
            </h2>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-medium-500 ">
              {aboutUs?.missionSubtitle}
            </p>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]">
              {aboutUs?.missionText}
            </p>

            <h2 className="text-gray-font sm:text-[17px] text-[16px] font-lato-semibold-600 mt-[20px] underline ">
              {aboutUs?.visionTitle}
            </h2>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-medium-500 ">
              {aboutUs?.visionSubtitle}
            </p>

            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]">
              {aboutUs?.visionText}
            </p>

            <h2 className="text-gray-font sm:text-[17px] text-[16px] font-lato-semibold-600 mt-[20px] underline ">
              {aboutUs?.whyTitle}
            </h2>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 ">
              <span className=" font-lato-medium-500">{aboutUs?.why1Bold}</span>{" "}
              {aboutUs?.why1}
            </p>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 ">
              <span className=" font-lato-medium-500">
                {" "}
                {aboutUs?.why2Bold}{" "}
              </span>
              {aboutUs?.why2}
            </p>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 ">
              <span className=" font-lato-medium-500">{aboutUs?.why3Bold}</span>{" "}
              {aboutUs?.why3}
            </p>

            <h2 className="text-gray-font sm:text-[17px] text-[16px] font-lato-semibold-600 mt-[20px] underline ">
              {aboutUs?.connectTitle}
            </h2>
            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-medium-500 ">
              {aboutUs?.connectText}
            </p>

            <p className="text-gray-font sm:text-[16px] text-[14px] font-lato-regular-400 mt-[20px]">
              {aboutUs?.finalNote}
            </p>
          </div>
        </div>
      </Container>
    </>
  );
};

export default AboutUs;
